import { useState } from 'react';

export default function NewsletterSection() {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState<'idle' | 'submitting' | 'success' | 'error'>('idle');
  const [errorMessage, setErrorMessage] = useState('');

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const formData = new FormData(form);
    const hpValue = (formData.get('phone_alt') as string || '').trim();

    if (hpValue) {
      setStatus('success');
      setEmail('');
      return;
    }

    if (!email.trim()) {
      setStatus('error');
      setErrorMessage('请输入邮箱地址');
      return;
    }

    setStatus('submitting');
    try {
      const payload = new URLSearchParams();
      payload.append('email', email.trim());
      formData.forEach((value, key) => {
        if (key !== 'phone_alt') {
          payload.append(key, value.toString());
        }
      });

      const response = await fetch('https://readdy.ai/api/form/d9qu42snlsngrm4lm650', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: payload.toString(),
      });

      const responseText = await response.text();
      let parsed;
      try { parsed = JSON.parse(responseText); } catch { parsed = null; }

      if (response.ok && parsed?.code === 'OK') {
        setStatus('success');
        setEmail('');
      } else {
        const serverMsg = parsed?.meta?.message || parsed?.message || responseText;
        setStatus('error');
        setErrorMessage(typeof serverMsg === 'string' ? serverMsg : '订阅失败，请稍后重试');
      }
    } catch {
      setStatus('error');
      setErrorMessage('网络错误，请检查连接后重试');
    }
  };

  return (
    <section className="relative py-20 md:py-26 overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Warm%20soft%20cream%20and%20golden%20abstract%20background%20with%20smooth%20organic%20textures%2C%20gentle%20gradients%2C%20butter%20colored%20tones%2C%20elegant%20minimal%20aesthetic%2C%20soft%20diffused%20light%2C%20no%20objects%2C%20pure%20abstract%20texture&width=1800&height=700&seq=newsletter-bg-butter&orientation=landscape"
        alt=""
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-primary-900/60"></div>

      <div className="relative z-10 container-site text-center">
        <div className="max-w-xl mx-auto">
          <span className="inline-block text-sm font-medium text-primary-200 bg-background-50/10 px-3 py-1 rounded-full mb-4">
            保持联系
          </span>
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-background-50 mb-3">
            订阅黄油作坊简报
          </h2>
          <p className="text-background-50/80 mb-8 leading-relaxed">
            每周获取最新的黄油制作教程、独家配方和手工美食灵感，让创意直达你的邮箱
          </p>

          {status === 'success' ? (
            <div className="bg-background-50/15 backdrop-blur-sm border border-background-50/20 rounded-2xl p-6">
              <div className="w-14 h-14 rounded-full bg-accent-500 flex items-center justify-center mx-auto mb-3">
                <i className="ri-check-line text-2xl text-background-50"></i>
              </div>
              <p className="text-background-50 font-semibold text-lg">订阅成功！</p>
              <p className="text-background-50/70 text-sm mt-1">感谢订阅，我们会定期为你推送精彩内容</p>
            </div>
          ) : (
            <form onSubmit={handleSubmit} className="flex flex-col sm:flex-row gap-3 max-w-md mx-auto" data-readdy-form>
              <div className="flex-1 relative">
                <input
                  type="email"
                  name="email"
                  value={email}
                  onChange={(e) => { setEmail(e.target.value); setStatus('idle'); }}
                  placeholder="输入你的邮箱地址"
                  className="w-full px-5 py-3.5 rounded-full bg-background-50/95 text-foreground-800 placeholder:text-foreground-400 text-sm outline-none border-2 border-transparent focus:border-primary-400 transition-colors"
                  required
                />
              </div>
              <input
                type="text"
                name="phone_alt"
                tabIndex={-1}
                autoComplete="off"
                aria-hidden="true"
                readOnly
                className="form-hp"
              />
              <button
                type="submit"
                disabled={status === 'submitting'}
                className="px-8 py-3.5 bg-accent-500 text-background-50 font-semibold rounded-full hover:bg-accent-600 transition-all duration-300 whitespace-nowrap cursor-pointer disabled:opacity-60"
              >
                {status === 'submitting' ? '订阅中...' : '立即订阅'}
              </button>
            </form>
          )}

          {status === 'error' && (
            <p className="text-red-300 text-sm mt-3">{errorMessage}</p>
          )}
        </div>
      </div>
    </section>
  );
}